export default "__VITE_ASSET__BY5at3ps__"